import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { CHATBOT_EDITOR } from '../../../constants/routes';
import PrimarySelect, { DropdownOption } from '../PrimarySelect';
import './PrimarySelectWithPush.pcss';

export type PrimarySelectWithPushProps = {
  className?: string;
  css?: {
    header?: string;
    select?: string;
  };
  options: DropdownOption[];
  value: DropdownOption;
  headerText?: string;
  onChange?: (option: DropdownOption) => any;
  showSearchFilter?: boolean;
  customDropdownStyles?: { zIndex: string };
};

export const PrimarySelectWithPush = (props: PrimarySelectWithPushProps) => {
  const {
    css = {},
    options,
    value,
    headerText,
    onChange,
    showSearchFilter = false,
    customDropdownStyles,
  } = props;
  const botId = useSelector(activeChatbotIdSelector);
  const history = useHistory();
  const headerClassList = classnames(
    'primary-select-with-push__header',
    css.header,
  );
  const primarySelectClassList = classnames(
    'primary-select-with-push__primary-select',
    css.select,
  );
  const onSelectedOptionChange = item => {
    const routeUrl = `${CHATBOT_EDITOR}/${botId}${item.url}`;
    history.push(routeUrl);
  };

  return (
    <>
      {headerText && <h1 className={headerClassList}>{headerText}</h1>}
      <PrimarySelect
        className={primarySelectClassList}
        onChange={onChange || onSelectedOptionChange}
        value={value}
        options={options}
        showSearchFilter={showSearchFilter}
        customDropdownStyles={customDropdownStyles}
      />
    </>
  );
};
